import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Euler, MathUtils } from 'three';
import { CustomObject } from '../../../types/data';
import { useTexture, useStorySlides } from '../../../hooks';
import { context } from '../../../config/context';
import StoryButton from './button';
import StoryActions from './actions';

// import storyBtnLeft from '../../../assets/images/xr/icons/story_btn_left.png';
// import storyBtnRight from '../../../assets/images/xr/icons/story_btn_right.png';

const { degToRad } = MathUtils;

const arrowWidth = 0.2585;
const arrowHeight = 0.5;
const arrowX = 0.12925;

type StoryWindowProps = {
  data: CustomObject;
  subtitles: any[];
  onClose: () => void;
};

const StoryWindow = ({ data, onClose }: StoryWindowProps) => {
  const slides = useStorySlides(data, []);
  const [{ activeSlideIndex }, setState] = useState({
    activeSlideIndex: 1,
  });

  const activeSlide = slides[activeSlideIndex];

  // const { texture: storyBtnLeftTxt } = useTexture(storyBtnLeft);
  // const { texture: storyBtnRightTxt } = useTexture(storyBtnRight);
  const src = activeSlide?.image?.original || '';
  const { texture: storyBgTxt } = useTexture(src);
  const { controls } = useContext(context);

  const handleSlideChange = useCallback(
    (index: number) => {
      index = Math.max(1, index);
      index = Math.min(slides.length - 1, index);

      setState(st => ({ ...st, activeSlideIndex: index }));
    },
    [slides]
  );

  useEffect(() => {
    controls?.current?.lookAtWithAnimation(new Euler(0, degToRad(-data.ath), 0, 'YXZ'));
  }, [data.id, data.audio_url, controls, data.ath]);

  return (
    <group rotation={[0, degToRad(-data.ath), 0, 'YXZ']}>
      <group position={[0, 0, -1]}>
        <group>
          <mesh position={[0, 0, 0]}>
            <planeBufferGeometry args={[0.5, 0.5]} attach="geometry" />
            <meshBasicMaterial attach="material" color="#ffffff" transparent map={storyBgTxt} />

            <group position={[0, 0, 0.01]}>
              <StoryButton
                main={{
                  width: arrowWidth,
                  height: arrowHeight,
                  material: { transparent: true, opacity: 0 },
                }}
                onClick={() => handleSlideChange(activeSlideIndex - 1)}
                position={[-arrowX, 0, 0]}
              />
              <StoryButton
                main={{
                  width: arrowWidth,
                  height: arrowHeight,
                  material: { transparent: true, opacity: 0 },
                }}
                onClick={() => handleSlideChange(activeSlideIndex + 1)}
                position={[arrowX, 0, 0]}
              />
            </group>
          </mesh>
          <StoryActions
            onClickClose={onClose}
            onToggleAudio={(e: any) => {}}
            onClickEdit={(e: any) => {}}
            onClickDelete={(e: any) => {}}
            showAudio={false}
          />
        </group>
      </group>
    </group>
  );
};

export default StoryWindow;
